import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Totes_ModuleContextService } from './Totes.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Totes_tote_types_grid_ComponentContextService {
  private readonly moduleContext: Totes_ModuleContextService;

  constructor(moduleContext: Totes_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'tote_types_grid',
      type: ComponentType.grid
    }
  }
}